import { Environment } from "./environment.model";

export const environment: Environment = {
    production: true,
    apiUrl: "https://api.nice-ops.recursyve.io",
    firebase: {
        apiKey: "AIzaSyCZH8mU8vscRg_VhwKPkdNL-9K7xy7tS2Y",
        authDomain: "nice-ops-production.firebaseapp.com",
        projectId: "nice-ops-production",
        storageBucket: "nice-ops-production.firebasestorage.app",
        messagingSenderId: "393086518994",
        appId: "1:393086518994:web:98fa420821f7a6b2edcf0b",
        measurementId: "G-EZHG5VTXRM"
    },
    sentry: {
        dsn: "https://d953e3072a902a6b59cf69bb5ff88106@o341312.ingest.us.sentry.io/4510358092775424",
        environment: "production",
        enabled: true
    }
};
